import React from 'react'
import AssistantContext from '../../../contexts/AssistantContext'
import StatusContext from '../../../contexts/StatusContext'
import {ResponseDisplay} from "../responsedisplay/ResponseDisplay"
import "./assistant.css"
import { useLocation } from 'react-router-dom'
import { useEffect } from "react";
import {NavBarStories} from '../navbarstories/NavBarStories'
import {PromptWithIcon} from '../promptwithicon/PromptWithIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'
import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import { WaitonResponse } from '../waitonresponse/WaitonResponse'
import AIButton from '../aibutton/AIButton'
import { DialogSelectModels } from '../aibutton/DialogSelectModels';

export const Assistant = () => {
    

    const alertYes = () => {
        console.log("AlertYes")
        onClearChat()
        closeDialogBox()
    }

    const alertCancel = () => {
        console.log("AlertCancel")
        closeDialogBox()
    }
    
    let {
        promptsandresponses, 
        onSummary,
        onClearChat,
        confirmDelete, 
        changeConfirmDelete,
        onDeletePrompt,
        displaySample,
        chatPrompt,
        setChatPrompt,
        onSubmitChat,
        isPromptandResponses,
        status,
        onResubmitChat,
    } = React.useContext(AssistantContext);

    let {
        isMobile, 
        scrollRef,
        changeLanguage,

        openDialog,
        openDialogBox,
        closeDialogBox,

        onCopy,
        focusRef,

        getAIName,
        getAIProvider,

        onClickAIButton,
       
    } = React.useContext(StatusContext);
   

    var  sample ='';
    const location = useLocation()
    if (location.state !== null)
         sample = location.state.sample

    useEffect(() => {

    const setSample = () => {
        
        if (sample)
        {
            displaySample(sample)
            
            location.state.sample = '';
        }
    }
    setSample();
  
   
    console.log("Assistant useEffect")

    }, [sample, displaySample, location.state])   
    
   
    
  return (

    <div className="homeContainer">
          
        
               {
                    isMobile() &&
                        <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
                }
             
                <NavBarStories title={changeLanguage('assistant', 'navbartitle_2')}/>
              
             
                <div className="response-markdown" ref={scrollRef} >
                    {
                        Array.isArray(promptsandresponses) &&
                            promptsandresponses.map((item) => (
                            <ResponseDisplay key= {item.id} displayprompt = {item} 
                                displayicons = {confirmDelete[promptsandresponses.indexOf(item)].state}
                                changeConfirmDelete = {changeConfirmDelete} 
                                onDeletePrompt = {onDeletePrompt} 
                                onResubmitQuestion={onResubmitChat} 
                                onCopy={onCopy}/>
                             ))
                    }
                </div> 
                {
                    (!status) &&
                        <WaitonResponse />
                }
                <hr className = 'separator'></hr>
        
                <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmitChat} placeholdertext={changeLanguage('assistant','promptplaceholder')}/>

                {
                    (status) && <label className = 'statusLabel'>{status}</label>
                }
                
                <div ref={focusRef} className="mainButtons">
                 
                    <Stack direction="row" spacing={2}>
                        {
                            !isMobile() &&
                               <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
                        }
                       
                        <PushButton onClick={openDialogBox} label =  {changeLanguage('assistant','clearall')}/>
                        {
                            (isPromptandResponses()) ?
                                <PushButton onClick={onSummary} label =  {changeLanguage('assistant','summary')}/>
                            :
                            null
                        }                       
                     
                        
                    </Stack>
                  
                   <AvailableCredits />
                </div> 

                <label style={{ width: isMobile() ? '100%' : '50%' }}>{changeLanguage("assistant", "note")}</label>
                
               
                <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')}/>
                <DialogSelectModels />
     </div>
  )
}


